import styled, { css } from 'styled-components';
import { gutter } from '../../../styles/variables';

const Body = styled.div`
  margin: ${gutter.large};
`;

const WrapperQuestion = styled.div`
  margin: ${gutter.large} 0;
`;

const TitleQuestion = styled.h3`
  ${props => props.noMargin && css`
    margin-bottom: 0;
  `}
`;

const Subtitle = styled.p`
  margin-left: ${gutter.large};
  ${props => props.noMargin && css`
    margin-top: 0;
  `}
`;

const Question = styled.p`
  margin: 0;

  ${props => props.marginLeft && css`
    margin-left: ${gutter.large};
  `}
`;

const WrapperButton = styled.div`
  text-align: center;

  ${props => props.marginTop && css`
    margin-top: ${gutter.large};
  `}
`;

const RadionItems = styled.div`
  margin-bottom: ${gutter.small};
`;

const LabelRadio = styled.div`
  cursor: pointer;
  margin-left: ${gutter.small};
`;

const WrapperSuccess = styled.div`
  text-align: center;
  margin: 50px 0;
`;

const WrapperTitle = styled.div`
  text-align: center;
  margin: 50px 0;
`;

const IMG = styled.img`
  width: 60%;
  height: auto;
  display: block;
  margin: 0 auto;
`;

export {
  Body,
  TitleQuestion,
  WrapperQuestion,
  Subtitle,
  WrapperButton,
  Question,
  LabelRadio,
  WrapperSuccess,
  RadionItems,
  WrapperTitle,
  IMG
}